<template lang="html">
  <div class="rear-content">
    <div class="rear-content-inner" v-if="workerInfo && workerInfo.uid">
      <header class="header" :style="{ backgroundImage: `url(${bgimg})` }">
        <div class="user-info">
          <div class="scanme" @click="toScanMe" v-if="!isCzjApp">
            <img src="../../assets/images/qrcode-p.png" />
          </div>
          <div class="user-inner">
            <div class="user-name">
              <p class="name">
                <span>{{ workerInfo.workerName }}</span>
              </p>
            </div>
            <div class="user-other">
              <p class="user-credentials">
                <template
                  v-if="
                    workerInfo.workerCredentials &&
                    workerInfo.workerCredentials.length > 0
                  "
                >
                  <span
                    v-for="credentialsRef in workerInfo.workerCredentials.slice(
                      0,
                      2
                    )"
                    class="part"
                    ><i class="iconfont font10 icon-zizhi"></i
                    >{{ credentialsRef.name }}</span
                  >
                </template>
              </p>
              <a
                class="shoppingName"
                @click="toShopp"
                v-if="workerInfo.storeName"
                ><i class="iconfont font10 icon-weizhi1"></i
                >{{ workerInfo.storeName }}</a
              >
            </div>
          </div>
        </div>
      </header>
      <section class="block-part">
        <statisticsIcons
          :shequUserInfo="shequUserInfo"
          :userInfo="workerInfo"
        ></statisticsIcons>
        <div
          class="profile-wrap"
          v-if="workerInfo.consultationTime || workerInfo.profile"
        >
          <p class="txt" v-if="workerInfo.consultationTime">
            咨询时间：{{ workerInfo.consultationTime }}
          </p>
          <div v-if="workerInfo.introduce">
            <p
              class="txt"
              v-model="shortProfile"
              :class="{ 'ui-nowrap-multi': profileArr.isLong }"
            >
              {{ workerInfo.introduce }}
            </p>
            <a
              class="btn"
              v-if="profileArr.isShow"
              :class="{ active: profileArr.isActive }"
              @click="profileFn()"
              ><i class="iconfont icon-xiajiantou"></i
            ></a>
          </div>
        </div>
      </section>
      <serviceList
        :list="userInfo.spuList"
        :empId="workerInfo.workerCode"
        pageId="140102"
        expandEventId="23011"
        collapseEventId="23010"
      ></serviceList>
      <!-- <shoppingList :total="shoppingList.num" :shoppingData="shoppingList.data || []" :uid="userInfo.uid" v-if="!isCzjApp"></shoppingList> -->
      <addIm :uid="uid" v-if="!isCzjApp" />
      <scrollerList title="顾问风采" :list="userInfo.picUrls">
        <li
          slot="scroller-items"
          v-for="(item, i) in userInfo.picUrls"
          @click="showImage(userInfo.picUrls, i)"
        >
          <img :src="$$viewImageInCenter(item, 300, 300)" />
        </li>
      </scrollerList>
      <!-- <scrollerList class="signlist-section" title="我的团队" :list="userInfo.group">
                <li slot="scroller-items" v-for="(item,i) in userInfo.group" @click="toUserHome(i,item.uid)">
                    <div class="img-warp">
                        <img :src="$$viewImageInCenter(item.headPicUrl,120,120) || default_avator" >
                        <p class="userTypeName">{{item.userType === 99 ? '认证育儿师' : '育儿顾问'}}</p>
                    </div>
                    <p class="name">{{item.workerName}}</p>
                </li>
            </scrollerList> -->
      <div
        class="g-section qa-section"
        v-if="oneAnswers && oneAnswers.length > 0"
      >
        <div class="g-title">
          <h2>
            咨询记录<i>/</i><span>共{{ shequUserInfo.comment_num }}条</span>
          </h2>
          <a
            :href="`//shequ.cekid.com/bbs/user/${workerInfo.uid}/qa?cmd=sqwd_person_answer&uid=${workerInfo.uid}&nickname=${workerInfo.workerName}`"
            @click="track(23017)"
          >
            <span class="more">更多<i class="iconfont icon-jiantou"></i></span>
          </a>
        </div>
        <div class="g-info">
          <qaList :myAnswers="oneAnswers"></qaList>
        </div>
      </div>
      <div
        class="g-section member-evaluate-section"
        v-if="
          memberComment && memberComment.list && memberComment.list.length > 0
        "
      >
        <div class="g-title">
          <h2>
            会员评价<i>/</i><span>共{{ memberComment.count }}条</span>
          </h2>
          <a href="javascript:;" @click="toMemberEvaluate(23019)">
            <span class="more">更多<i class="iconfont icon-jiantou"></i></span>
          </a>
        </div>
        <div class="g-info">
          <div class="g-info-comment">
            <commentItem
              source="member"
              v-for="(comment, i) in memberComment.list"
              :comment="comment"
              :key="comment.id"
              :flagLog="true"
              :index="i"
            ></commentItem>
            <a href="javascript:;" @click="toMemberEvaluate(23018)"></a>
          </div>
          <div class="seeAllComment">
            <a href="javascript:;" @click="toMemberEvaluate(23019)"
              >查看全部评价 <i class="iconfont icon-jiantou"></i
            ></a>
          </div>
        </div>
      </div>
      <!-- <div class="g-section member-evaluate-section" v-if="experience && experience.length > 0 && !isCzjApp">
                <div class="g-title">
                    <h2>社区动态</h2>
                    <a href="javascript:;" @click="toExperience(23021)">
                        <span class="more">更多<i class="iconfont icon-jiantou"></i></span>
                    </a>
                </div>
                <div class="g-info">
                    <div class="g-info-comment">
                        <postItem :experience="experience[0]" :ommitContent="true"></postItem>
                    </div>
                    <div class="seeAllComment">
                        <a href="javascript:;" @click="toExperience(23021)">查看全部 <i class="iconfont icon-jiantou"></i></a>
                    </div>
                </div>
            </div> -->
    </div>
    <div class="footer" v-if="ispauid">
      <span class="setPauid" v-if="pauid == workerInfo.uid"
        >她是您的专属育儿顾问</span
      >
      <span class="setPauid" @click="setMyPauid" v-else
        >设为我的专属育儿顾问</span
      >
    </div>
    <template v-else>
      <actionbar v-if="isCzjApp">
        <button class="btns btn-pink" slot="buttons">
          <a
            class="ui-border-r btn pingjia"
            :href="`//life.cekid.com/v/user/${workerInfo.uid}/comment/add`"
            @click="track(23023)"
          >
            <span>评价</span>
          </a>
        </button>
      </actionbar>
      <actionbar v-else class="rearAction">
        <li slot="icons">
          <a
            class="ui-border-r btn pingjia"
            :href="`//life.cekid.com/v/user/${workerInfo.uid}/comment/add`"
            @click="track(23023)"
          >
            <i class="iconfont icon-pingjia"></i><span>评价</span>
          </a>
        </li>
        <!-- <button class="btns btn-ccc" slot="buttons" @click="unfollow" v-if="shequUserInfo.is_follow"><a><i class="iconfont icon-yihaoyou"></i>已加好友</a></button>
                <button class="btns btn-cancel" slot="buttons" @click="follow" v-else><a><i class="iconfont icon-jiahaoyou"></i>加为好友</a></button> -->
        <button class="btns btn-pink btn-round" slot="buttons">
          <a
            class="ui-border-r contactMe linkedme"
            :href="`https://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${workerInfo.uid}`"
            @click="toIM($event)"
            ><i class="iconfont icon-liaotian"></i>找她聊聊</a
          >
        </button>
      </actionbar>
    </template>
    <empty
      v-else
      v-show="!firstFetch"
      :image="require('../../assets/images/empty1.png')"
      text="未找到相关信息"
    ></empty>
    <imagePreview :items="previewImages"></imagePreview>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'
import commentItem from '@/components/rear/item'
// import postItem from '@/components/rear/item-experience'
import imagePreview from '@/components/common/viewImage'
import orderTime from '@/components/rear/order-time'
import datePrompt from '@/components/date/prompt'
import empty from '@/components/common/empty'
import actionbar from '@/components/order/actionbar'
import qaList from '@/components/rear/qaList'
// import shoppingList from '@/components/rear/shoppingList'
import scrollerList from '@/components/rear/scrollerList'
import serviceList from '@/components/rear/personalServiceList'
import addIm from '@/components/common/im'
import statisticsIcons from './statisticsIcons'

export default {
  data() {
    return {
      uid: null,
      attrsTxt: [],
      credentialsNameArr: [],
      profileArr: {
        isLong: false,
        isShow: false,
        isActive: false
      },
      schedualAreasStr: [],
      schedualWaresShow: {
        width: '100%'
      },
      moveX: 0,
      pageX: null,
      evaluateLis: [],
      evaluateLisNum: null,
      firstFetch: false,
      shequUserInfo: { is_follow: false, comment_num: 0, fans_num: 0 },
      // is_follow: false,
      show_follow_relation: false,
      memberComment: {},
      experience: {},
      signList: [],
      answerList: [],
      ispauid: false,
      pauid: '',
      // shoppingList: {},
      default_pic: require('../../assets/images/default_yegw_bg.jpg'),
      default_avator: require('../../assets/images/default_yegw_avator.png'),
      groupId: ''
    }
  },
  async created() {
    this.uid = this.$route.params.uid || this.$$cookie('uid')
    this.ispauid = this.$route.query.ispauid || false
    this.pauid = this.$route.query.pauid || ''
    // await this.getUserInfo()
    this.getUserInfoFromShequ()
    this.getAnswers()
    if (this.ispauid || this.ispauid === 'true') {
      this.getUserInfoFromUser()
    }
    this.$$loading(false)
    const name = this.workerInfo.workerName
    const genius = this.workerInfo.workCategorys
      .map(ele => ele.service_name)
      .join('、')
    const desc = `孩子王育儿服务平台${this.workerInfo.workerName}为您提供专业服务，擅长${genius}`
    const shareRemark = {
      // https://doc.weixin.qq.com/sheet/e3_AHcAFgYQAOQ5JzaHs1ySymwTlnHNW
      // toolType
      // 401	服务分享赚
      // 402	心愿单
      // 403	代客下单
      // --------------
      // contentType\contentId
      // 201	服务商祥	SPUID
      // 202	服务拼团商祥	SKUID
      // 203	服务景区详情	SPUID
      // 204	服务频道页	CHANNEL_ID
      // 205	服务天天特价频道页
      // 206	服务晒图有奖
      // 207	服务店铺	BUSINESSID
      // 208	服务人格化主页	WORKERID
      // toolType,
      // toolCode,
      url: encodeURIComponent(location.href),
      contentType: 208,
      contentId: this.workerInfo.uid || ''
      // storeCode,
      // groupId,
      // phoneNumber
    }
    this.$$share({
      link: `https://life.cekid.com/v/user/${this.uid}`,
      desc,
      title: `店长${name}的名片`,
      imgUrl: this.workerInfo.headImage,
      remark: JSON.stringify(shareRemark)
    })
    const shareInfo = {
      title: `店长${name}`,
      desc: '孩子王，中国新家庭全渠道服务商！',
      link: `https://life.cekid.com/v/user/${this.uid}`,
      imgUrl: this.workerInfo.headImage
    }
    window.getImInfo = () => shareInfo
    this.$$title(`店长${name}`)
    this.$$tracker('140102', '10000', '11050', this.uid, name)
  },
  async mounted() {
    try {
      // this.getShoppingList()
      this.getMemberEvaluate()
      if (!this.isCzjApp) {
        this.getExperience()
      }
      // this.getSignListByCode()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    async getUserInfoFromUser() {
      const res = await this.$store.dispatch('getUserInfoFromUser', {
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        padetail: 1
      })
      // console.log(res);
      if (res.uid && res.pauid) {
        this.pauid = res.pauid
      }
    },
    track(eventId, param) {
      this.$$tracker('140102', '20000', eventId, param)
    },
    showImage(images, index) {
      this.$$tracker('140102', '20000', '23014', index)
      // const arr = images.map(img => img.downloadurl)
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    serviceDisplay(attr) {
      if (attr) {
        const attr_names = attr.map(ele => ele.service_name)
        return attr_names.join('、') || '暂未开通服务'
      }
      return '暂未开通服务'
    },
    async getAnswers() {
      const res = await this.$store.dispatch('getAnswers', {
        uid: this.workerInfo.uid
      })
      if (res.code === 1001) {
        this.answerList = res.data || []
      }
    },
    async getUserInfoFromShequ() {
      const user_shequ = await this.$store.dispatch('getUserInfoFromShequ', {
        // uid: this.$$cookie('uid'),
        to_uid: this.uid
      })
      const plus = await this.$store.dispatch('getUserInfoPlusFromShequ', {
        to_uid: this.uid
      })
      this.show_follow_relation = true
      if (user_shequ.code === 1001) {
        this.shequUserInfo.is_follow = user_shequ.data.is_follow
        this.shequUserInfo.fans_num = user_shequ.data.fans_num
      }
      if (plus.code === 1001) {
        this.shequUserInfo.comment_num = plus.data.comment_num
      }
    },
    profileFn() {
      if (this.profileArr.isLong) {
        this.profileArr.isLong = false
        this.profileArr.isActive = true
        this.$$tracker('140102', '20000', '23007')
      } else {
        this.profileArr.isLong = true
        this.profileArr.isActive = false
        this.$$tracker('140102', '20000', '23008')
      }
    },
    serviceShowTrigger(e) {
      const iel = e.currentTarget.querySelector('i')
      iel.classList.toggle('rotate')
      document
        .querySelector('.service-part li.addborder')
        .classList.toggle('withborder')
      const els = [...document.querySelectorAll('.service-part li.needHide')]
      els.forEach(el => {
        el.classList.toggle('hide')
      })
      if (iel.classList.contains('rotate')) {
        this.$$tracker('140102', '20000', '23010')
      } else {
        this.$$tracker('140102', '20000', '23011')
      }
    },
    async getEvaluate() {
      try {
        const extendStr = JSON.stringify({
          community: this.uid
        })
        const evaluatelist = await this.$store.dispatch('getEvaluatePage', {
          extend: extendStr,
          page: 1,
          size: 2,
          show_user: 1,
          show_reply: 1
        })
        if (evaluatelist.code === 1001) {
          this.evaluateLis = evaluatelist.data.list
          this.evaluateLisNum = evaluatelist.data.count
        } else {
          this.$$toast({
            message: evaluatelist.message
          })
        }
      } catch (e) {
        // this.hasErr = true
      }
    },
    toScanMe() {
      if (this.$$isHZWApp()) {
        location.href = `https://shequ.cekid.com/update.html?cmd=sqqrcode&uid=${
          this.uid
        }&nickname=${encodeURIComponent(this.workerInfo.workerName)}&usertype=1`
      } else {
        location.href = `https://party.cekid.com/entry/app/v1.html?cmd=sqqrcode&uid=${
          this.uid
        }&nickname=${encodeURIComponent(this.workerInfo.workerName)}&usertype=1`
      }
    },
    toQa() {
      location.href = `//shequ.cekid.com/bbs/user/${this.uid}/qa?cmd=sqwd_person_answer&uid=${this.uid}&nickname=${this.workerInfo.workerName}`
    },
    toShopp() {
      if (this.isCzjApp) return
      location.href = `//w.cekid.com/store/?code=${this.workerInfo.storeCode}`
    },
    toPay($event) {
      $event.preventDefault()
      this.$$tracker('140102', '20000', '23024')
      if (this.$$isRkhy()) {
        window.location = '//shequ.cekid.com/dynamic/yegw/update.html'
      } else {
        window.location = `//shequ.cekid.com/dynamic/yegw/pay.html?uid=${this.workerInfo.uid}`
      }
    },
    toIM($event) {
      $event.preventDefault()
      this.$$tracker('140102', '20000', '23025')
      if (this.$$isHZWApp() || this.$$isRkhy()) {
        if (this.workerInfo.userType === 1 || this.workerInfo.userType === 4) {
          window.location = `//im.cekid.com/shequ/chat/?targetId=${this.workerInfo.uid} &cmd=imconversation&scenetype=11&userid=${this.workerInfo.uid}&refresh=no`
        } else {
          window.location.href = event.currentTarget.getAttribute('href')
        }
      } else {
        window.location.href = event.currentTarget.getAttribute('href')
      }
    },
    toUserHome(index, uid) {
      this.$$tracker('140102', '20000', '23015', index, uid)
      location.href = `/v/user/${uid}`
    },
    async follow() {
      const follow_res = await this.$store.dispatch('doFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.shequUserInfo.is_follow = true
        const ele_toast = [...document.querySelectorAll('.cekid-toast')]
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        this.$$toast('已加好友，可在通讯录中查看')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
      this.$$tracker('140102', '20000', 23001)
    },
    async unfollow() {
      const follow_res = await this.$store.dispatch('deleteFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.shequUserInfo.is_follow = false
        const ele_toast = [...document.querySelectorAll('.cekid-toast')]
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        // this.$$toast('取消关注成功')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
      this.$$tracker('140102', '20000', 23002)
    },
    async getMemberEvaluate() {
      const comment = await this.$store.dispatch('getMemberEvaluate', {
        uid: this.uid
      })
      if (comment.code === 1001) {
        this.memberComment = comment.data
      }
    },
    toMemberEvaluate(num) {
      this.$$tracker('140102', '20000', num)
      location.href = `${this.$$hostname('life')}/v/comments/${
        this.workerInfo.uid
      }`
    },
    toExperience(num) {
      this.$$tracker('140102', '20000', num)
      location.href = `//shequ.cekid.com/bbs/user/${this.workerInfo.uid}?cmd=usercard&userType=0&userid=${this.workerInfo.uid}&user=true`
    },
    async getExperience() {
      const exp = await this.$store.dispatch('getBBSList', {
        to_uid: this.uid,
        limit_num: 1
      })
      if (exp.code === 1001) {
        this.experience = exp.data
      }
    },
    async setMyPauid() {
      try {
        const { uid, skey } = await this.$$ensureLogin()
        const pauid = this.workerInfo.uid
        const source = 1
        const json = await this.$store.dispatch('setModifyBasicUserInfo', {
          uid,
          skey,
          pauid,
          source
        })
        if (json && json.errno === 0) {
          this.$$toast(json.errmsg || '设置成功')
          this.pauid = pauid
        } else if (json && json.errno === 1024) {
          this.$$login()
        } else {
          this.$$toast(json.errmsg || '系统异常，稍后再试')
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  components: {
    star,
    commentItem,
    imagePreview,
    orderTime,
    datePrompt,
    empty,
    actionbar,
    // postItem,
    qaList,
    // shoppingList,
    scrollerList,
    serviceList,
    addIm,
    statisticsIcons
  },
  computed: {
    ...mapState(['userInfo', 'previewImages']),
    workerInfo() {
      return this.userInfo.worker
    },
    commentScaleNum() {
      return this.userInfo.userCommentScale * 100
    },
    bgimg() {
      return this.$$viewImageInCenter(
        this.workerInfo.headImage || this.default_pic,
        750,
        554
      )
    },
    startLevelNum() {
      return this.workerInfo.starLevel * 2
    },
    shortProfile() {
      if (this.workerInfo.introduce && this.workerInfo.introduce.length > 45) {
        this.profileArr.isLong = true
        this.profileArr.isShow = true
      }
    },
    oneAnswers() {
      if (this.answerList.length > 0) {
        return this.answerList.slice(0, 1)
      } else {
        return this.answerList
      }
    },
    isCzjApp() {
      return this.$$isCZJApp()
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';
.block-part {
  .small-block {
    .star-wrapper ul {
      padding-left: rem(52px);
      padding-top: rem(5px);
      padding-bottom: rem(5px);
    }
  }
}
.actionbar {
  @include border(top);
  .action-others {
    li {
      // @include border(right);
    }
    .iconfont {
      color: #666;
    }
  }
  .btns a {
    display: block;
    color: #fff !important;
    .iconfont {
      padding-right: rem(10px);
    }
  }
  .btn-round {
    // max-width: rem(600px);
    border-radius: rem(40px);
    a {
      height: rem(80px);
      line-height: rem(80px);
    }
  }
}
.signlist-section {
  .scroller-warp {
    height: rem(200px) !important;
    .ui-scroller {
      li:first-child {
        margin-left: rem(25px) !important;
      }
      li {
        position: relative;
        width: rem(200px) !important;
        height: rem(200px) !important;
        margin-left: 0 !important;
        .img-warp {
          width: rem(120px);
          height: rem(120px);
          border-radius: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          overflow: hidden;
        }
        .userTypeName {
          position: absolute;
          width: rem(120px);
          height: rem(40px);
          line-height: rem(40px);
          text-align: center;
          bottom: 0;
          left: 50%;
          font-size: rem(18px);
          color: #fff;
          background-color: rgba(0, 0, 0, 0.3);
          transform: translate(-50%, 0);
        }

        img {
          width: rem(120px);
          height: rem(120px);
          border-radius: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
        }

        .name {
          font-size: rem(28px);
          color: #121212;
          text-align: center;
          margin-top: rem(135px);
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.rear-content {
  overflow-x: hidden;
  // padding-top: rem(100px);
  .rear-content-inner {
    margin-bottom: rem(100px);
  }
  header {
    width: 100%;
    height: rem(554px);
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/default_yegw_bg.jpg');

    // .user-scan{
    //     position: absolute;
    //     left:rem(565px);
    //     top:rem(30px);
    //     width:rem(160px);
    //     height:rem(50px);
    //     border-radius: rem(25px);
    //     background-color:#ff397e;
    //     color:#fff;
    //     font-size: rem(28px);
    //     text-align: center;
    //     line-height: rem(50px);
    //     .iconfont{
    //         padding-right:rem(12px);
    //     }
    // }
    .focus-bt {
      position: absolute;
      left: rem(585px);
      top: rem(30px);
      width: rem(140px);
      height: rem(50px);

      .follow-trigger {
        opacity: 0.9;
        height: rem(50px);
        width: rem(140px);
        line-height: rem(50px);
        background: #ff397e;
        color: #fff;
        font-size: rem(28px);
        border-radius: rem(20px);
        text-align: center;
        @include border(all, #ff397e, 1px, 20px);

        .icon-jia {
          font-size: rem(28px);
          margin-right: rem(10px);
          font-weight: bold;
        }
      }

      .hasFocus {
        background: #fff;
        color: #666;
        @include border(all, #dfdfdf, 1px, 20px);
      }
    }

    .user-info {
      background: rgba(0, 0, 0, 0.5);
      background-size: 100% 100%;
      position: absolute;
      bottom: 0;
      height: rem(110px);
      width: 100%;
      padding: rem(20px) rem(24px);

      .scanme {
        position: absolute;
        top: 0;
        right: rem(25px);
        width: rem(170px);
        height: rem(48px);
        z-index: 1;

        img {
          width: rem(170px);
          height: rem(48px);
        }
      }

      .user-name {
        overflow: hidden;
        font-size: rem(32px);
        color: #fff;
        position: relative;
        display: flex;
        .name {
          flex: 1;

          span {
            display: inline-block;
            vertical-align: bottom;
          }
          .service-star {
            display: inline-block;
            margin-left: rem(10px);
            width: rem(28px);
            height: rem(34px);
            background-image: url('../../assets/images/service-star-gw.png');
            background-size: cover;
            background-repeat: no-repeat;
          }
        }

        .icons-identify {
          margin-left: rem(5px);
          vertical-align: text-bottom;
        }
      }
      .user-other {
        padding-top: rem(4px);
        display: flex;
        align-items: center;
      }
      .user-credentials {
        flex: 1;

        .part {
          margin-right: rem(19px);
          font-size: rem(22px);
          color: #fff;
          .iconfont {
            margin-right: rem(8px);
            font-size: rem(24px);
          }
        }
      }
      .shoppingName {
        text-align: right;
        // flex:1;
        display: block;
        // margin-top: rem(10px);
        width: rem(340px);
        font-size: rem(26px);
        color: #fff;
        .iconfont {
          font-size: rem(24px);
        }
      }
    }
  }

  .block-part {
    background-color: #fff;
    // position:relative;
    margin-bottom: rem(20px);
    .small-block {
      display: flex;
      align-items: center;
      height: rem(132px);

      a {
        display: block;
        // padding-bottom: rem(20px);
        .txt {
          // padding-top: rem(16px);
        }
      }
      li {
        flex: 1;
        // height:rem(132px);
        .title {
          display: block;
          color: #999999;
          font-size: rem(24px);
          text-align: center;
        }
        .txt {
          display: block;
          color: #121212;
          font-size: rem(24px);
          text-align: center;
          i {
            font-size: rem(36px);
          }
        }
        .score {
          margin: rem(32px) auto rem(12px);
          padding-left: 0;
          width: rem(160px);
          display: block;
          overflow: hidden;
        }
      }
    }

    .profile-wrap {
      margin: 0 rem(25px);
      padding: rem(25px) 0;
      // padding: rem(25px);
      @include border(top);
      font-size: rem(28px);
      color: #121212;
      .txt {
        margin-bottom: rem(4px);
        line-height: rem(36px);
      }
      .btn {
        display: block;
        margin-bottom: rem(-16px);
        text-align: center;
        transition: all 200ms;
        i {
          color: #999999;
        }
      }
      .active {
        transform: rotate(-180deg);
      }
      .iconfont {
        font-size: rem(24px);
      }
    }
  }
  .qa-section,
  .evaluate-section,
  .member-evaluate-section {
    .g-info {
      // padding: rem(20px) 0;
      .g-info-comment {
        position: relative;

        .comment-item:last-child::after {
          border-bottom: 0 none;
        }
        > a {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          z-index: 2;
        }
      }
      .seeAllComment {
        text-align: center;
        padding: rem(30px) rem(30px) rem(10px);
        font-size: rem(28px);
        @include border(top);

        &::before {
          left: rem(20px);
          right: rem(20px);
        }

        a {
          display: inline-block;
          padding: 0 rem(20px);
          height: rem(50px);
          line-height: rem(50px);
        }
        .icon-jiantou {
          font-size: rem(22px);
        }
      }
      .btn-bottom {
        display: block;
        margin: 0 auto rem(10px);
        width: rem(210px);
        height: rem(48px);
        font-size: rem(28px);
        color: #121212;
        line-height: rem(48px);
        text-align: center;
        @include border(all, #121212);
      }
    }
  }
  .identify-section {
    .g-info {
      .txt {
        padding: rem(30px) rem(20px);
        font-size: rem(26px);
        color: #666;
        // border-bottom: rem(1px) solid #E5E5E5;
        line-height: rem(42px);
        @include border(bottom, #e5e5e5);
      }
      .msg {
        display: flex;
        .part {
          display: flex;
          padding: rem(30px) 0 rem(30px) rem(40px);
          flex: 1;
          .icon {
            display: block;
            width: rem(80px);
            height: rem(80px);
            margin-right: rem(20px);
          }
          .icon1 {
            background: url(../../assets/images/icon1_bg.png) no-repeat;
            background-size: cover;
          }
          .icon2 {
            background: url(../../assets/images/icon2_bg.png) no-repeat;
            background-size: cover;
          }
          .name {
            flex: 1;
            p {
              padding: rem(10px) 0;
              font-size: rem(28px);
              color: #121212;
            }
            span {
              font-size: rem(24px);
              color: #999999;
            }
          }
          .icon-youjiantou {
            font-size: rem(26px);
            vertical-align: text-top;
          }

          &:last-child {
            @include border(left, #e5e5e5);
          }
        }
      }
    }
  }

  .g-right-line {
    // border-right: 1px solid #e5e5e5;
  }
  .g-section {
    margin-top: rem(20px);
    background: #ffffff;
    .g-title {
      display: flex;
      align-items: center;
      height: rem(100px);
      line-height: rem(100px);
      padding-left: rem(25px);
      padding-right: rem(25px);
      background: #fff;

      > h2 {
        flex: 1;
        font-size: rem(32px);
        font-weight: 600;

        > span {
          color: #999;
          font-size: rem(28px);
          font-weight: normal;
        }
        > i {
          font-weight: normal;
          color: #999;
          margin: 0 rem(10px);
        }
      }
      > a {
        align-self: flex-start;
        font-size: rem(26px);
      }
      .more {
        font-size: rem(26px);
        text-align: right;
      }
      .icon-jiantou {
        display: inline-block;
        font-size: rem(22px);
        transform: rotate(-90deg);
      }
    }
    .g-info {
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: rem(100px);
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 0 10px rgba(0, 204, 204, 0.5);
    box-shadow: 0 0 0, 0 0 0, 0 -3px 3px rgba(0, 0, 0, 0.06), 0 0 0;
    .aList {
      display: flex;
      overflow: hidden;
    }
    a {
      box-sizing: border-box;
      height: rem(100px);
      padding: rem(20px) 0;
      text-align: center;
      font-size: rem(22px);
      color: #ff397e;
    }

    .iconfont {
      margin-right: rem(10px);
      font-size: rem(48px);
      line-height: rem(50px);
    }
    .btn {
      flex: 1;
      padding: rem(10px) 0;
      .iconfont {
        margin-right: 0;
        margin-bottom: rem(10px);
        color: #666666;
      }
    }
    .pingjia {
      border-right: rem(1px) solid #dddddd;
      border-left: rem(1px) solid #dddddd;
    }
    .contactMe {
      width: rem(400px);
      font-size: rem(32px);
      background-color: #ff6ea2;
      color: #ffffff;
    }
    span {
      display: block;
      line-height: rem(30px);
      color: #121212;
    }
    .setPauid {
      display: block;
      height: rem(100px);
      background-color: #ff6ea2;
      color: #ffffff;
      font-size: rem(32px);
      text-align: center;
      line-height: rem(100px);
    }
  }
}
</style>
